"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.getTestContext = exports.UnifiedLogin = void 0;var _commands = require("./commands");












var _config = require("./models/config");
var _messageHandler = require("./messageHandler");
var _state = require("./models/state");
var _clientState = require("./utils/clientState");
var _activityWatcher = require("./activityWatcher");
var _utils = require("./utils");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _callbacks = require("./utils/callbacks");






var _url = require("./utils/url");
var _logging = require("./utils/logging");
var _const = require("./const");





const DEFAULT_AUTH_ROOT_URL = 'https://start.flashparking.com';
const tokenExpirationBufferSeconds = 30;

let config = new _config.UnifiedConfig();
let state = new _state.UnifiedState();
let lastTokenCheck;

/**
 * Unified Login Namespace
 * */
class UnifiedLogin {
  /**
   * Unified Login Commands
   */
  static get commands() {return _commands.Command.Commands;}

  /**
   * Unified Login Command Responses
   */
  static get commandResponses() {return _commands.Command.CommandResponses;}

  /**
   * The designated client type for the portal
   **/
  static get clientType() {return config.clientType;}

  /**
   * The registered Client redirect Uri
   */
  static get redirectUri() {return config.redirectUri;}

  /**
   * The URL of the Unified/SSO site
   */
  static get unifiedLoginUrl() {return config.unifiedLoginUrl;}

  /**
   * holds a reference to the iframe that contains a authentication component
   * */
  static get authenticationFrame() {return config.authenticationFrame;}

  /**
   * The callback methods that handle responses to Unified Login Authentication Component API commands
   * */
  static get callbacks() {return config.callbacks;}

  /**
   * holds references to authentication tokens
   **/
  static get currentAuthentication() {return state.currentAuthentication;}

  /**
   * holds an object whose properties describe the current user
   * */
  static get currentUser() {return state.currentUser;}

  /**
   * A collection of our client portals
   */
  static get clientPortals() {return config.clientPortals;}

  static get options() {
    return Object.freeze(Object.assign({}, config.options));
  }

  /**
   * initializes authentication communication
   * - registers the iframe hosting the authentication component
   * - registers callback methods
   * - creates necessary event handlers for communication
   * @param unifiedLoginUrl address of unified login
   * @param clientType contains the designated site name for the portal
   * @param redirectUri
   * @param authFrame iframe element with auth component
   * @param options
   * @param callback - a callback method called when complete
   */
  static initialize(
  unifiedLoginUrl,
  clientType,
  redirectUri,
  authFrame,
  options,
  callback)
  {
    if (!clientType || clientType.length === 0) {
      throw new Error("clientType is required");
    }

    if (!redirectUri || redirectUri.length === 0) {
      throw new Error("redirectUri is required");
    }

    //merge users options on top of defaults
    options = {
      autoRefresh: true,
      autoLogout: false,
      autoLogoutInMinutes: _const.DEFAULT_INACTIVE_MINUTES,
      autoLogoutWarningMinutes: _const.DEFAULT_WARNING_MINUTES,
      ...(options || {})
    };

    _activityWatcher.ActivityWatcher.init({
      onActiveIntervalCallback: handleUserActivity,
      onInactiveIntervalCallback: handleUserInactivity,
      onLogoutWarningCallback: handleLogoutWarning
    });
    if (options.autoRefresh || options.autoLogout) {
      lastTokenCheck = new Date().getTime();
      _activityWatcher.ActivityWatcher.start(options.autoLogoutInMinutes, options.autoLogoutWarningMinutes);
    }

    //default to info if missing or invalid
    if (!options.logLevel || !Object.values(_logging.LogLevel).includes(options.logLevel)) {
      options.logLevel = _logging.LogLevel.info;
    }
    _logging.Logger.setLogLevel(options.logLevel);

    config = new _config.UnifiedConfig();
    state = new _state.UnifiedState();

    config.authenticationFrame = authFrame;
    config.clientType = clientType;
    config.redirectUri = redirectUri;
    config.unifiedLoginUrl = (0, _url.removeTrailingSlash)(unifiedLoginUrl ?? DEFAULT_AUTH_ROOT_URL);
    config.options = options;

    // Register the call back
    const commandId = registerTemporaryCallback(callback, _commands.Command.Commands.initialize);

    // Add an event handler for communication from auth component.
    window.addEventListener('message', eventListenerCallback);

    // Set auth component styles on load.
    if (config.authenticationFrame) {
      config.authenticationFrame.onload = () => UnifiedLogin.onLoadEvent(commandId);
    }

    // Add dialog
    //addAuthDialog();

    return commandId;
  }

  static onLoadEvent = (commandId) => {
    //Now that our frame is loaded, send the initialize command
    (0, _commands.initializeCommand)(commandId, config);
  };

  /**
   * Registers a callback that will receive all messages from the component api
   * @param id
   * @param callback
   */
  static registerCallback(id, callback) {
    if (!id || !callback) return;
    if (typeof callback !== "function") {
      throw new Error("Callback should be a function. Actual: " + typeof callback);
    }
    callback.bind(this);
    config.callbacks[id] = callback;
    _logging.Logger.debug(`registered callback: ${id}`, Object.keys(config.callbacks));
  }

  /**
   * Unregisters a callback by its ID
   * @param id
   */
  static unregisterCallback(id) {
    if (!id) return;
    delete config.callbacks[id];
    _logging.Logger.debug(`unregistered callback: ${id}`, Object.keys(config.callbacks));
  }

  /**
   * Initiates the Authentication process for the user
   * @param options
   * @param clientState - a client supplied value that is returned with the response
   */
  static authorize(options, clientState) {var _options;
    options = options || {};
    const encodedClientState = (0, _clientState.prepare)(clientState);
    (0, _commands.authorizeCommand)(config, (_options = options) === null || _options === void 0 ? void 0 : _options.username, encodedClientState);
  }

  /**
   * Exchanges an authentication code for authentication tokens
   * @param code - authentication code
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   */
  static redeemAuthenticationCode(code, clientState, callback) {
    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.redeemCode);
    (0, _commands.redeemAuthenticationCodeCommand)(id, config, state, code, encodedClientState);
    return id;
  }

  /**
   * checks if the current user is authenticated by querying  api
   * @param options
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   */


  /**
   * checks if the current user is authenticated by querying  api
   * @param redirect - determines if the user should be redirected to login page if not authenticated
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   * @deprecated Use the CheckAuthenticationOptions version of this method
   */


  /**
   * checks if the current user is authenticated by querying  api
   * @internal Overloaded logout method
   */
  static checkAuthentication(redirectOrOptions, clientState, callback) {
    let options = redirectOrOptions;
    if (typeof redirectOrOptions === "boolean") {
      options = {
        redirect: redirectOrOptions
      };
      _logging.Logger.warn("argument 'redirect' has been deprecated. Use [CheckAuthenticationOptions] options instead.");
    }
    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.checkAuthentication);
    (0, _commands.checkAuthenticationCommand)(id, config, state, options, encodedClientState);
    return id;
  }

  /**
   * Logs out the current user
   * @param options - Logout Options
   * @param clientState -The raw client state object
   * @param callback - a callback method called when complete
   */


  /**
   * Logs out the current user
   * @param clientOnlyLogout - Determines if the user is logged out of both the SSO and the client portal, or just the portal.
   * @param redirectToLogin - Determines if the user should be redirected to a login page after logout
   * @param clientState - The raw client state object
   * @param callback - a callback method called when complete
   * @deprecated - Use the LogoutOptions version of this method
   */


  /***
   * Logs out the current user
   * @internal Overloaded logout method
   */
  static logout(clientOnlyOrOptions, redirectOrClientState, clientStateOrCallback, callback) {
    let clientState;
    let options = {
      clientOnly: false,
      redirect: false
    };

    if (typeof clientOnlyOrOptions === "boolean") {
      options.clientOnly = clientOnlyOrOptions;
    } else {
      options = clientOnlyOrOptions;
    }

    if (typeof redirectOrClientState === "boolean") {
      options.redirect = redirectOrClientState;
      clientState = clientStateOrCallback;
    } else {
      clientState = redirectOrClientState;
      callback = clientStateOrCallback;
    }

    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.logout);
    (0, _commands.logoutCommand)(id, config, state, options.clientOnly, options.redirect, encodedClientState);
    return id;
  }

  /**
   * Refreshes client tokens
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   */
  static refreshTokens(clientState, callback) {
    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.refreshTokens);
    (0, _commands.refreshTokensCommand)(id, config, state, encodedClientState);
    return id;
  }

  /**
   * Changes the current user's password
   * @param currentPassword
   * @param newPassword
   * @param logout - indicates that the user should be logged out after the password change
   * @param redirect - indicates that if the user is logged out, the application should be redirected to a login page
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   */
  static changePassword(
  currentPassword,
  newPassword,
  logout,
  redirect,
  clientState,
  callback)
  {
    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.changePassword);
    (0, _commands.changePasswordCommand)(id, config, state, currentPassword, newPassword, logout, redirect, encodedClientState);
    return id;
  }

  /**
   * method that updates the profile of the current user
   * @param user
   * @param clientState - a client supplied value that is returned with the response
   * @param callback - a callback method called when complete
   */
  static updateProfile(user, clientState, callback) {
    const encodedClientState = (0, _clientState.prepare)(clientState);
    const id = registerTemporaryCallback(callback, _commands.Command.Commands.updateProfile);
    (0, _commands.updateProfileCommand)(id, config, state, user, encodedClientState);
    return id;
  }

  /**
   * Starts the user registration process by forwarding the user to the SSO portal
   * @param token - user registration token
   * @param clientState - a client supplied value that is returned with the response
   */
  static startRegistration(token, clientState) {
    const encodedClientState = (0, _clientState.prepare)(clientState);
    (0, _commands.startRegistrationCommand)(config, token, encodedClientState);
  }
}exports.UnifiedLogin = UnifiedLogin;

const handleUserActivity = () => {
  const elapsedMs = new Date().getTime() - (lastTokenCheck || 0);
  if (!config.options.autoRefresh || !_activityWatcher.ActivityWatcher.isActive || elapsedMs <= _const.TOKEN_CHECK_INTERVAL_SECONDS * 1000) return false;

  lastTokenCheck = new Date().getTime();
  const tokens = state.currentAuthentication;
  let refreshRequired = !tokens.accessToken || !tokens.idToken;

  if (!tokens.refreshToken) {
    _logging.Logger.warn("Unable to refresh -- no refreshToken");
    (0, _commands.authorizeCommand)(config);
    return false;
  } else if (!refreshRequired) {
    // determine our next check time w/a buffer. If the expiration is after that time (+ buffer) we'll require a refresh
    const accessToken = (0, _utils.parseToken)(tokens.accessToken);
    const nextCheck = (0, _dayjs.default)().add(_const.TOKEN_CHECK_INTERVAL_SECONDS + tokenExpirationBufferSeconds, "second");
    refreshRequired = accessToken ? nextCheck.isAfter(_dayjs.default.unix(accessToken.exp)) : true;
  }

  if (refreshRequired) {
    _logging.Logger.info("token refresh is required");
    (0, _commands.refreshTokensCommand)((0, _callbacks.createCallbackId)("auto-refresh-token"), config, state);
    return true;
  }

  return false;
};

const handleUserInactivity = (secondsInactive) => {
  if (_activityWatcher.ActivityWatcher.isActive) return false;

  const { autoLogout, autoLogoutInMinutes } = config.options;

  const minutesInactive = secondsInactive / 60;
  if (autoLogout && minutesInactive >= autoLogoutInMinutes) {
    const id = (0, _callbacks.createCallbackId)(_commands.Command.Commands.logout);
    (0, _commands.logoutCommand)(id, config, state, false, true);
  }
};

const handleLogoutWarning = (logoutSeconds) => {
  const { autoLogout } = config.options;
  if (!autoLogout) return false;
  const id = (0, _callbacks.createCallbackId)(_commands.Command.Commands.logoutWarning);
  (0, _commands.logoutWarningCommand)(id, config, state, logoutSeconds);
};

const registerTemporaryCallback = (callback, command) => {
  const id = (0, _callbacks.createCallbackId)(command);
  if (callback) {
    UnifiedLogin.registerCallback(id, callback);
  }
  return id;
};

const eventListenerCallback = (e) => {
  //Ignore events that are sent by the host (client portal)
  if (e.origin === window.location.origin) {
    return;
  }

  if (e.origin === config.unifiedLoginUrl) {
    (0, _messageHandler.handleMessage)(e, config, state);
  } else {
    _logging.Logger.warn("Posted message origin does not match expected, stop processing", {
      expected: config.unifiedLoginUrl,
      actual: e.origin,
      message: e
    });
  }
};

const getTestContext = () => {
  return {
    config,
    state,
    eventListenerCallback,
    handleUserActivity,
    handleUserInactivity,
    handleLogoutWarning,
    tokenExpirationBufferSeconds,
    setLastTokenCheck: (dt) => {lastTokenCheck = dt;}
  };
};exports.getTestContext = getTestContext;